import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useI18n } from '@newtontechnologies/applib-frontend';
import './style.less';
const { Dragger } = Upload;
const FileSplitterUpload = (({ accept, onChange, }) => {
    const { intl } = useI18n();
    const triggerChange = (info) => {
        if (info.file.status === 'removed' || info.fileList[0].originFileObj === undefined) {
            onChange(null);
        }
        else {
            // NOTE: the onChange method on Ant dragger does not return - contrary to Ant docs -
            // the UploadFile type, so it is neccesary to use the fileList which contains RcFile
            onChange(info.fileList[0].originFileObj);
        }
    };
    return (_jsxs(Dragger, { className: "file-dragger", beforeUpload: () => false, maxCount: 1, onChange: triggerChange, accept: accept, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(UploadOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: intl.formatMessage({ id: 'mediaFile' }) }), _jsx("p", { className: "ant-upload-hint", children: intl.formatMessage({ id: 'dragDrop' }) })] }));
});
export default FileSplitterUpload;
